import {Injectable} from '@angular/core';
import {ContextualService} from "@modules/gamecode/core/services/contextual.service";

@Injectable({
    providedIn: 'root'
})
export class ServicesInstantiatorService {

    constructor(
        private contextualService: ContextualService,
    ) {
    }
}
